const ArrowExternalIcon = () => `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.07154 12.5563L12.5568 4.07106M12.5568 4.07106L5.01435 4.07106M12.5568 4.07106L12.5568 11.6135" stroke="currentColor" stroke-width="2"></path></svg>
  `;
export default ArrowExternalIcon;
